




































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { CardForm } from '@/components/bwaff';
import Form from '@/components/form-base';
import { pick } from 'lodash';
import { GeneralApi } from '../api';
import { mixins } from 'vue-class-component';
import CurrencyMixin from '@/components/helpers/currency-mixin';
import UrlMixin from '@/components/query/url-mixin';
import UiRadioGroup from '@/components/ui/ui-radio-group.vue';

@Component({
  components: {
    UiRadioGroup,
    CardForm,
  }
})
export default class Reporting extends mixins(Form, CurrencyMixin, UrlMixin) {
  @Prop() 
  api: GeneralApi;

  @Prop() 
  data: any;

  error: boolean = false;
  error_message: string = '';
  edit: boolean = false;
  show_password: boolean = false;
  email: string = '';
  password: string = '';
  placeholderTimezone: boolean = true;
  placeholderGrouping: boolean = true;
  placeholderSorting: boolean = true;

  form: any = {};

  default_group_list: any = [
    {value: 'revenue', text: this.t('Revenue')},
    {value: 'cost', text: this.t('Cost')},
    {value: 'profit', text: this.t('Profit')},
    {value: 'visits', text: this.t('Visits')},
    {value: 'clicks', text: this.t('Clicks')},
    {value: 'conversions', text: this.t('Conversions')}
  ];

  reportSearchSettingItems = [
    {value: 'allTabs', text: this.t('Save search across all report tabs')},
    {value: 'perTab', text: this.t('Apply search per tab')},
  ];

  conversion_time_list: any = [
    {value: 'asc', text: this.t('Ascending')},
    {value: 'desc', text: this.t('Descending')}
  ];

  mounted() {
    this.fillForm(this.$store.state.user);
  }

  openExchangeRatesDialog() {
    this.bus.emit('open-dialog', { name: 'ExchangeRatesDialog' });
  }

  fillForm(source: any) {
    this.form.showCountry = source.reportCampaignsName == 'full' || source.reportCampaignsName == 'country-only';
    this.form.showTrafficSource = source.reportCampaignsName == 'full' || source.reportCampaignsName == 'traffic-source-only';

    this.form = {
      ...this.form,
      ...pick(source, [
        'defaultTimezone',
        'defaultHomepage',
        'postbackDate',
        'dashboardDefaultGroup',
        'dashboardDefaultOrderDir',
        'reportCampaignsName',
        'reportOffersName',
        'reportLandingsName',
        'reportFlowsName',
        'preferredCurrency',
        'independentColumnSettingsEnabled',
        'reportTotalLabelEnabled',
        'reportSearchSetting'
      ])
    };

    if(this.$store.state.timezoneList) {
      this.placeholderTimezone = false;
    }

    if(this.default_group_list) {
      this.placeholderGrouping = false;
    }

    if(this.conversion_time_list) {
      this.placeholderSorting = false;
    }
  }

  @Watch('$store.state.user')
  dataReceived(val: any) {
    this.fillForm(val);
  }

  trackAnalytics(event) {
    const { independentColumnSettingsEnabled } = this.form;

    this.$mixpanel?.track(event, {
      independent_columns_settings: independentColumnSettingsEnabled,
    });
  }

  cancel() {
    this.edit=false;
    this.fillForm(this.$store.state.user);
  }

  // @Send()
  submit() {
    this.form.reportCampaignsName = 'full';

    if (this.form.showCountry && !this.form.showTrafficSource) {
      this.form.reportCampaignsName = 'country-only';
    }

    if (!this.form.showCountry && this.form.showTrafficSource) {
      this.form.reportCampaignsName = 'traffic-source-only';
    }

    if (!this.form.showCountry && !this.form.showTrafficSource) {
      this.form.reportCampaignsName = 'campaign-only';
    }

    return this.api.put(this.form).then((res: any) => {
      this.trackAnalytics('settings_reporting')

      this.$store.commit('updateUser', res);
      this.edit = false;
      this.bus.emit('toast-success', this.t('Changes have been successfully saved'));

      this.updateQueries();

      return this.api.updateDashboardQuery(res);
    });
  }

  updateQueries(){
    const { currencyId, preferredCurrency } = this.$store.state.user;

    if(!preferredCurrency.includes(this.$store.state.table.query.currency)){
      this.$store.commit('tableQuery', {
        name:'currency',
        value: currencyId
      });
    }

    this.$store.commit('tableQuery', {
      notSetToLocalStorage: false,
      name:'timezone',
      value: this.form.defaultTimezone
    });

    this.$store.commit('dashboardQuery', {
      notSetToLocalStorage: false,
      name:'timezone',
      value: this.form.defaultTimezone
    });

    this.$store.commit('clearTableQuerySearch');
    
  }

  get currencyListOrderedItems() {
    const { currencyId } = this.$store.state.user;

    return this.currencyListOrdered.map((item:any)=>{
      if(item.code === currencyId){
        item.disabled = true;
      }
      return item;
    })
  }
}
